import store from "./store";

export class ApiUrls {
  private readonly uriEnv: string = '/';
  public readonly OtpSend: string;
  public readonly OtpCheck: string;
  public readonly IdentityInsert: string;
  public readonly UploadCapture: string;
  public readonly GetAgreement: string;
  public readonly GenerateAgreement: string;
  public readonly SendLink: string;
  public readonly GetStatus: string;
  public readonly GetStatusUi: string;
  public readonly AddLog: string;
  public readonly AddStep: string;
  public readonly AbortRequest: string;
  public readonly Translations: string;
  public readonly StartFlow: string;
  public readonly NextFlowState: string;
  public readonly CurrentFlowState: string;
  public readonly NextStateForCaptureError: string;
  public readonly CitizenshipList: string;
  public readonly SetCitizenship: string;
  public readonly IdList: string;
  public readonly SetId: string;
  public readonly CheckValidity: string;
  public readonly SetTwoSidedId: string;

  constructor() {
    if (store.environment === 'QA' || store.environment === 'DEMO') {
      this.uriEnv = '/dev_';
    } else {
      this.uriEnv = '/';
    }
    this.OtpSend = this.uriEnv + 'validation/otp/send';
    this.OtpCheck = this.uriEnv + 'validation/otp/check';
    this.IdentityInsert = this.uriEnv + 'validation/identity/insert';
    this.UploadCapture = this.uriEnv + 'validation/upload/capture';
    this.GetAgreement = this.uriEnv + 'validation/agreement/content';
    this.GenerateAgreement = this.uriEnv + 'validation/agreement/generate';
    this.SendLink = this.uriEnv + 'validation/otp/sendlink';
    this.GetStatus = this.uriEnv + 'validation/identity/status';
    this.GetStatusUi = this.uriEnv + 'validation/identity/statusui';
    this.AddLog = this.uriEnv + 'validation/logs/add';
    this.AddStep = this.uriEnv + 'validation/logs/step';
    this.AbortRequest = this.uriEnv + 'validation/identity/abort';
    this.Translations = this.uriEnv + 'validation/translations/get';
    this.StartFlow = this.uriEnv + 'validation/flowstate/startflow';
    this.NextFlowState = this.uriEnv + 'validation/flowstate/nextstate';
    this.CurrentFlowState = this.uriEnv + 'validation/flowstate/currentstate';
    this.NextStateForCaptureError = this.uriEnv + 'validation/flowstate/nextstateforcaptureerror';
    this.CitizenshipList = this.uriEnv + 'validation/flows/citizenships';
    this.IdList = this.uriEnv + 'validation/flows/ids';
    this.SetCitizenship = this.uriEnv + 'validation/identity/setcitizenship';
    this.SetId = this.uriEnv + 'validation/identity/setidentitydocument';
    this.CheckValidity = this.uriEnv + 'validation/upload/isvalidid';
    this.SetTwoSidedId = this.uriEnv + 'validation/identity/settwosided';
  }
}
